// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TOC_E","comment":"styles_comment__3EDWJ"};